export default __webpack_public_path__ + "static/media/06_kobieta_z_kura.2bb69a02.png";